import { economicActivityApi } from "../api";

const EconomicActivityService = {
    /**
     * Obtener todas las actividades económicas.
     */
    getAll: async () => {
        try {
            const response = await economicActivityApi.fetchAll();
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getDropdown: async (filters: { query?: string }) => {
        try {
            const response = await economicActivityApi.addCustom('/dropdown', filters);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * 🔄 Obtener dropdown completo sin filtros (recarga).
     */
    getAllDropdown: async () => {
        try {
            const response = await economicActivityApi.fetchCustom('/dropdown/all');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Buscar actividad económica por nombre.
     */
    findByName: async (name: string) => {
        try {
            const response = await economicActivityApi.fetchCustom(`/search?name=${name}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Crear una nueva actividad económica.
     */
    save: async (data: Object) => {
        try {
            const response = await economicActivityApi.add(data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Actualizar el nombre de una actividad económica.
     */
    update: async (data: object) => {
        try {
            const response = await economicActivityApi.update(data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Activar o desactivar una actividad económica.
     */
    deactivate: async (id: number) => {
        try {
            const response = await economicActivityApi.patchCustom(`${id}/toggle-status`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

}

export default EconomicActivityService;
